import Vue from "vue";

export const toast = {
  info: (message: string) => Vue.$toast.info(message)
};
